import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ProductNav from '@/components/ProductCommon/ProductNav';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import ProductSupport from '@/components/ProductCommon/ProductSupport';
import PageConH5 from '@/componentsH5/ProductDelta/deltapronew';
import PageConPc from '@/components/ProductDelta/deltapronew';
import SEOlinksA from '@/components/SEOlinksA';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useSupportData } from '@/utils/hooks';
import Annotation from '@/components/Annotation';
import { useLang } from '@/i18n';

// 产品详情页参数
const productName = 'delta-pro-portable-power-station';

const whiteLocaleList: string[] = ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'eu', 'kr', 'br', 'tw', 'mx', 'ph', 'nl'];
export default function Page({ SEO }: any) {
    const { isMobile, gloproductlist, useRouter, useState, useEffect, useLang } = useGlobal();
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const [theme, setTheme] = useState('black');
    const router = useRouter();
    const { locale } = router;

    const generalKey = locale === 'ph' ? 'product_ps_delta_delta_pro_plus' : 'product_ps_delta_delta_pro';

    const { t } = useLang('delta_pro_new');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    // 如果不存在该页面,返回404
    // if (typeof window !== 'undefined' && !productMsg.generalKey && gloproductlist?.length) {
    //     return router?.push('/404');
    // }
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);
    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
    };

    useEffect(() => {
        if (!whiteLocaleList.includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <>
            <SEO title={productMsg?.title || t('seo_title')} description={productMsg?.description || t('seo_desc')} />
            <SEOlinksA list={whiteLocaleList} locale={locale} pathname={productMsg.url} />
            <GtmPageLoad />
            <PageLayout
                isNoFixed
                className={`${css.productcontent} ${theme} product_common`}
                theme={theme}
                navChildren={
                    <>
                        <ProductNav
                            className="wbg"
                            title={productMsg?.name}
                            theme={theme}
                            buyLink={productMsg?.buyLink}
                            callback={tabState}
                            productKey={productName}
                        />
                    </>
                }
            >
                <div className="product-tab product-tab-Overview show-tab">
                    <PageCon />
                    <Annotation borderTopColor="transparent" bgColor="transparent" boxStyle={isMobile ? {} : { width: '1120px' }} />
                </div>
                <div className="product-tab product-tab-Specs">
                    <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />
                </div>
                <div className="product-tab product-tab-Support">
                    <ProductSupport theme={theme} supportData={supportData}></ProductSupport>
                </div>
            </PageLayout>
        </>
    );
}
